import { Component, OnInit } from '@angular/core';
import { TwilioDeviceService } from 'app/twilio-device/twilio-device.service';
import { Store } from '@ngxs/store';
import { CallState } from 'app/store/call/call.state';
import { Observable } from 'rxjs';
import { ActiveCall } from 'app/models/dto/call.model';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-softphone-dialpad',
  templateUrl: './softphone-dialpad.component.html',
  styleUrls: ['./softphone-dialpad.component.scss'],
  standalone: false
})
export class SoftphoneDialpadComponent implements OnInit {

  call$: Observable<ActiveCall> = this.store.select(CallState.call);
  activeCall: ActiveCall;
  dialpadHistory = '';

  buttons = [
    {label: '1', sublabel: '', value: '1'},
    {label: '2', sublabel: 'abc', value: '2'},
    {label: '3', sublabel: 'def', value: '3'},
    {label: '4', sublabel: 'ghi', value: '4'},
    {label: '5', sublabel: 'jkl', value: '5'},
    {label: '6', sublabel: 'mno', value: '6'},
    {label: '7', sublabel: 'pqrs', value: '7'},
    {label: '8', sublabel: 'tuv', value: '8'},
    {label: '9', sublabel: 'wxyz', value: '9'},
    {label: '*', sublabel: null, value: '*'},
    {label: '0', sublabel: null, value: '0'},
    {label: '#', sublabel: null, value: '#'},
  ];

  constructor(
    private twilioDeviceService: TwilioDeviceService,
    private store: Store,
  ) { }

  ngOnInit() {
    this.call$.pipe(take(1)).subscribe((activeCall) => {
      this.activeCall = activeCall;
    });
  }

  handleDigit(digit: string) {
    this.dialpadHistory += digit;
    this.twilioDeviceService.sendDigits(digit);
  }
}
